import React from 'react';
import ConnectButtons from '../components/ConnectButtons';
import '../Landing.css';

const Landing = () => {
    return (
        <div className="home-container">
            <h1 className='home-title-h1'>Welcome to the CatBonds Application</h1>
            <h2 className='home-title'>Connect to a Network</h2>
            <ConnectButtons />
        </div>
    );
};

export default Landing;
